import { client } from "./supabase";

// ─── PLAN COBROS (facturas emitidas) ─────────────────────

export const getPlanCobros = async (facturaSiiEmitidaId) => {
  const { data, error } = await client
    .from("plan_cobros_facturas")
    .select("*")
    .eq("factura_sii_emitida_id", facturaSiiEmitidaId)
    .order("numero_cuota");
  if (error) throw error;
  return data || [];
};

export const crearPlanCobros = async (cuotas) => {
  const { data, error } = await client.from("plan_cobros_facturas").insert(cuotas).select();
  if (error) throw error;
  return data || [];
};

export const actualizarCuotaCobro = async (id, cambios) => {
  const { data, error } = await client.from("plan_cobros_facturas").update(cambios).eq("id", id).select().single();
  if (error) throw error;
  return data;
};

export const eliminarPlanCobros = async (facturaSiiEmitidaId) => {
  const { error } = await client
    .from("plan_cobros_facturas")
    .delete()
    .eq("factura_sii_emitida_id", facturaSiiEmitidaId);
  if (error) throw error;
};

// ─── PLAN PAGOS (facturas recibidas) ─────────────────────

export const getPlanPagos = async (facturaSiiRecibidaId) => {
  const { data, error } = await client
    .from("plan_pagos_facturas")
    .select("*")
    .eq("factura_sii_recibida_id", facturaSiiRecibidaId)
    .order("numero_cuota");
  if (error) throw error;
  return data || [];
};

export const crearPlanPagos = async (cuotas) => {
  const { data, error } = await client.from("plan_pagos_facturas").insert(cuotas).select();
  if (error) throw error;
  return data || [];
};

export const actualizarCuotaPago = async (id, cambios) => {
  const { data, error } = await client.from("plan_pagos_facturas").update(cambios).eq("id", id).select().single();
  if (error) throw error;
  return data;
};

export const eliminarPlanPagos = async (facturaSiiRecibidaId) => {
  const { error } = await client
    .from("plan_pagos_facturas")
    .delete()
    .eq("factura_sii_recibida_id", facturaSiiRecibidaId);
  if (error) throw error;
};

// ─── Obtener todas las cuotas futuras pendientes ──────────

export const getCuotasCobrosFuturas = async (pais) => {
  const hoy = new Date().toISOString().split("T")[0];
  const { data, error } = await client
    .from("plan_cobros_facturas")
    .select(
      `
      *,
      factura:facturas_sii_emitidas(
        folio, razon_social_receptor, pais
      )
    `
    )
    .eq("estado", "pendiente")
    .gt("fecha_vencimiento", hoy)
    .eq("factura.pais", pais)
    .order("fecha_vencimiento");
  if (error) throw error;
  return data || [];
};

export const getCuotasPagosFuturas = async (pais) => {
  const hoy = new Date().toISOString().split("T")[0];
  const { data, error } = await client
    .from("plan_pagos_facturas")
    .select(
      `
      *,
      factura:facturas_sii_recibidas(
        folio, razon_social_emisor, pais
      )
    `
    )
    .eq("estado", "pendiente")
    .gt("fecha_vencimiento", hoy)
    .eq("factura.pais", pais)
    .order("fecha_vencimiento");
  if (error) throw error;
  return data || [];
};
